<template>
  <div>
    <router-link :to="pathDashboard" id="container"
      class="text-background-academy-600 font-sans-serif">
      <div class="flex justify-start items-start pb-0 lg:pb-3 group mx-auto"
        :class="containerClass">
        <img :src="person.urlProfilePhoto ? person.urlProfilePhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png'" alt="foto profilo" id="photo"
          class="rounded-full"
          :class="photoClass ? photoClass : 'w-10 lg:w-12'">
        <h1 class="hover:border-white w-full ease-in-out hover:translate-x-1
          transform hover:-translate-y-2 duration-500" :class="textClass"
          id="title">{{person.name}}</h1>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['person', 'isTeacher', 'containerClass', 'textClass', 'photoClass'],

  computed: {
    pathDashboard() {
      if (this.isTeacher) {
        return `/teachers/${this.person.slug}`;
      }
      return `/students/${this.person.slug}`;
    },
  },
};
</script>
